import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MappingTemplate} from "../../_models/mappingTemplate";
import {MappingService} from "../../_services/mapping.service";

@Component({
    standalone: false,
  selector: "select-mapping-template",
  templateUrl: 'select-mapping-template.component.html',
  styleUrls: ['./select-mapping-template.component.scss'],
})
export class SelectMappingTemplateComponent implements OnInit {
  mapppingTemplates: MappingTemplate[] = [];
  currentUser: User;
  recurringList: any;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public mappingService: MappingService,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectMappingTemplateComponent>) {
  }

  ngOnInit() {
    this.mappingService.getMappingTemplates().subscribe(m => {
      this.mapppingTemplates = m;
    });
  }
  selectMappingTemplate(data)
  {
    this.dialogRef.close(data.mappingTemplateId);
  }
}
